import { BusinessObjectBase } from './base';
import type { Interview } from './interview';

export interface InterviewProblemSolvingData {
  readonly id: number;
  readonly problemSolvingScore?: number;
  readonly notes?: string;
  readonly interviewId: number;
  readonly interview?: Interview;
}

export interface InterviewProblemSolving extends Readonly<InterviewProblemSolvingData> {}
export class InterviewProblemSolving extends BusinessObjectBase {
  static readonly entityName = 'InterviewProblemSolving' as const;
  static readonly plural = 'interview-problem-solvings';

  // --- Static CRUD methods ---

  static async find(filter?: any): Promise<InterviewProblemSolving[]> {
    const url = `${this.baseUrl}/${this.plural}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const results = await this.get<any[]>(url, params);
    return results.map((data) => new InterviewProblemSolving(data));
  }

  static async findOne(filter?: any): Promise<InterviewProblemSolving | null> {
    const url = `${this.baseUrl}/${this.plural}/find-one`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return data ? new InterviewProblemSolving(data) : null;
  }

  static async findById(
    id: number,
    filter?: any,
  ): Promise<InterviewProblemSolving> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const params: Record<string, string> = {};
    if (filter) params['filter'] = JSON.stringify(filter);
    const data = await this.get<any>(url, params);
    return new InterviewProblemSolving(data);
  }

  static async create(
    data: Omit<InterviewProblemSolvingData, 'id'>,
  ): Promise<InterviewProblemSolving> {
    const url = `${this.baseUrl}/${this.plural}`;
    const result = await this.post<any>(url, data);
    return new InterviewProblemSolving(result);
  }

  static async updateById(
    id: number,
    data: Partial<InterviewProblemSolvingData>,
  ): Promise<InterviewProblemSolving> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    const result = await this.patch<any>(url, data);
    return new InterviewProblemSolving(result);
  }

  static async deleteById(id: number): Promise<boolean> {
    const url = `${this.baseUrl}/${this.plural}/${id}`;
    try {
      await this.del<void>(url);
      return true;
    } catch {
      return false;
    }
  }
}
